import { render, staticRenderFns } from "./AddressModel.vue?vue&type=template&id=1c07c55c&scoped=true"
import script from "./AddressModel.vue?vue&type=script&lang=js"
export * from "./AddressModel.vue?vue&type=script&lang=js"
import style0 from "./AddressModel.vue?vue&type=style&index=0&id=1c07c55c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c07c55c",
  null
  
)

export default component.exports